<template>
  <div class="dsfa-password-iframe-input" :style="{ height: height }">
    <el-input
      v-if="!hideStandingInput"
      class="dsfa-password-iframe-el-input"
      placeholder="请输入密码"
      ref="dsfa-password-el-input"
    ></el-input>
    <iframe
      v-if="elInputHeight"
      class="dsfa-password-iframe-input_input"
      ref="iframe"
      :srcdoc="srcdoc"
      frameborder="0"
      tabindex="0"
      :style="{
        width,
        opacity: loaded ? 1 : 0,
      }"
    ></iframe>
  </div>
</template>

<script>
import inputHtml from "./inputHtml.txt";
export default {
  name: "PasswordIframeInput",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    height: {
      default: "1.12rem",
    },
    width: {
      default: "100%",
    },
    value: {
      default: "",
    },
    disabled: {
      default: false,
    },
  },
  data() {
    return {
      loaded: false,
      hideStandingInput: false,
      elInputHeight: 0,
    };
  },
  computed: {
    srcdoc() {
      return inputHtml;
    },
  },
  created() {},
  mounted() {
    this.elInputHeight = this.$refs["dsfa-password-el-input"].$el.clientHeight;
    this.$nextTick(() => {
      this.contentWindow = this.$refs.iframe.contentWindow;
      const stop = setInterval(() => {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
        if ($(this.contentWindow.document).find(".el-input").length) {
          clearInterval(stop);
          this.loaded = true;
          this.onloadBefore(this.contentWindow);
          this.contentWindow.onInputChange = (v) => {
            this.$emit("change", v);
          };
          this.contentWindow.onInputInput = (v) => {
            this.$emit("input", v);
          };
          this.contentWindow.onInputFocus = (v) => {
            this.$emit("focus", v);
          };
          this.contentWindow.onInputBlur = (v) => {
            this.$emit("blur", v);
          };
          this.contentWindow.onInputKeydown = (v) => {
            this.$emit("keydown", v);
          };
          setTimeout(() => {
            this.hideStandingInput = true;
          }, 1000);
        }
      }, 10);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    onloadBefore(window) {
      let cDdocument = window.document;
      let documentDom = $(cDdocument);
      let inputWarpDom = documentDom.find(".el-input");
      this.inputWarpDom = inputWarpDom;
      let inputDom = documentDom.find(".el-input__inner");
      let closeDom = documentDom.find(".el-icon-circle-close");
      let viewDom = documentDom.find(".el-icon-view");
      let isHover = false;
      let isFocus = false;
      cDdocument.addEventListener("focus", function (e) {
        if (e.target == cDdocument) {
          inputDom[0].focus();
        }
      });
      this.disabled && this?.inputWarpDom?.addClass("is-disabled");
      inputWarpDom.hover(
        function () {
          isHover = true;
          updateClose();
        },
        function () {
          isHover = false;
          updateClose();
        }
      );
      viewDom.on("click", function () {
        var type = inputDom.attr("type");
        if (type == "password") {
          inputDom.attr("type", "text");
          viewDom.addClass("el-icon-close-view");
        } else if (type == "text") {
          inputDom.attr("type", "password");
          viewDom.removeClass("el-icon-close-view");
        }
      });
      closeDom.on("click", function () {
        inputDom.val("");
        inputDom.focus();
      });
      inputDom
        .on("focus", function () {
          isFocus = true;
          updateClose();
          window?.onInputFocus?.(inputDom.val());
        })
        .on("blur", function () {
          isFocus = false;
          window?.onInputBlur?.(inputDom.val());
        })
        .on("input", function () {
          updateClose();
          window?.onInputInput?.(inputDom.val());
        })
        .on("change", function () {
          window?.onInputChange?.(inputDom.val());
        })
        .on("keydown", function (ev) {
          window?.onInputKeydown?.(ev);
        });
      function updateClose() {
        var val = inputDom.val();
        if (!val) {
          closeDom.hide();
        } else if (isHover) {
          closeDom.show();
        }
      }
    },
    handleResize() {
      this.contentWindow = this.$refs.iframe.contentWindow;
      if ($(this.contentWindow.document).find(".el-input").length) {
        let htmlDom = $(this.contentWindow.document).find("html")[0];
        let width = window.innerWidth;
        let maxWidth = 1920;
        let minWidth = 1366;
        let initHtmlFontSize = 50;
        let htmlFontSize = 50;
        if (width > maxWidth) {
          htmlFontSize = initHtmlFontSize + "px";
        } else if (minWidth <= width && width <= maxWidth) {
          htmlFontSize = (width / maxWidth) * initHtmlFontSize + "px";
        } else {
          htmlFontSize = (minWidth / maxWidth) * initHtmlFontSize + "px";
        }
        // 媒体查询器
        if (width <= 1690) {
          $(this.contentWindow.document).find(
            "input.el-input__inner"
          )[0].style.fontSize = "14px";
        } else {
          $(this.contentWindow.document).find(
            "input.el-input__inner"
          )[0].style.fontSize = "0.32rem";
        }
        htmlDom.style.fontSize = htmlFontSize;
      }
    },
  },
  watch: {
    disabled(v) {
      v && this.inputWarpDom?.addClass("is-disabled");
    },
  },
};
</script>
<style>
.dsfa-password-iframe-input {
  position: relative;
}
.dsfa-password-iframe-el-input {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  height: 100%;
}
.dsfa-password-iframe-input_input {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  height: 100%;
}
</style>
